/*
Please use real model data returned from Player
*/
import afta from './img/afta.svg';
import aftb from './img/aftb.svg';
import aftm from './img/aftm.svg';
import aftmm from './img/aftmm.svg';
import aftn from './img/aftn.svg';
import aftr from './img/aftr.svg';
import afts from './img/afts.svg';
import aftt from './img/aftt.svg';
import brightsign from './img/brightsign.svg';
import browser from './img/browser.svg';
import intelcs from './img/intelcs.svg';
import mibox from './img/mibox.svg';
import miboxs from './img/miboxs.svg';
import firep1 from './img/firep1.svg';
import platformAmazon from './img/platform-amazon.svg';
import platformAndroid from './img/platform-android.svg';
import platformChromeos from './img/platform-chromeos.svg';
import platformWindows from './img/platform-windows.svg';
import platformMac from './img/platform-mac.svg';
export var platformList = [
    {
        platform: 'amazon',
        name: 'Amazon Fire OS',
    },
    {
        platform: 'android',
        name: 'Android',
    },
    {
        platform: 'chromeos',
        name: 'Chrome OS',
    },
    {
        platform: 'mac',
        name: 'macOS',
    },
    {
        platform: 'osx',
        name: 'macOS',
    },
    {
        platform: 'ios',
        name: 'iPadOS/iOS',
    },
    {
        platform: 'linux',
        model: 'firep1',
        name: 'ScreenCloud OS',
    },
    {
        platform: 'linux',
        name: 'Linux',
    },
    {
        platform: 'windows',
        name: 'Windows',
    },
    {
        platform: 'brightsign',
        name: 'BrightSign',
    },
    {
        platform: 'browser',
        name: 'Browser',
    },
    {
        platform: 'other',
        name: 'Unknown Device',
    },
];
export var devicesList = [
    // ScreenCloud OS
    {
        model: 'firep1',
        name: 'Station P1',
        src: firep1,
    },
    // Amazon Devices
    {
        model: 'AFTA',
        name: 'Fire TV Cube (Gen 1)',
        src: afta,
    },
    {
        model: 'AFTB',
        name: 'Fire TV (Gen 1)',
        src: aftb,
    },
    {
        model: 'AFTM',
        name: 'Fire TV Stick (Gen 1)',
        src: aftm,
    },
    {
        model: 'AFTMM',
        name: 'Fire TV Stick 4K',
        src: aftmm,
    },
    {
        model: 'AFTN',
        name: 'Fire TV (Gen 3)',
        src: aftn,
    },
    {
        model: 'AFTR',
        name: 'Fire TV Cube (Gen 2)',
        src: aftr,
    },
    {
        model: 'AFTS',
        name: 'Fire TV (Gen 2)',
        src: afts,
    },
    {
        model: 'AFTT',
        name: 'Fire TV Stick (Gen 2)',
        src: aftt,
    },
    {
        model: 'AFTSS',
        name: 'Fire TV Stick Lite (2020)',
        src: aftt,
    },
    {
        model: 'AFTSSS',
        name: 'Fire TV Stick (Gen 3)',
        src: aftt,
    },
    {
        model: 'AFTRS',
        name: 'Fire TV Edition - Element 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTEAMR311',
        name: 'Fire TV Edition - Insignia HD',
        src: platformAmazon,
    },
    {
        model: 'AFTSO001',
        name: 'Fire TV Edition - JVC 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTKMST12',
        name: 'Fire TV Edition - Toshiba 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTBAMR311',
        name: 'Fire TV Edition - Toshiba HD',
        src: platformAmazon,
    },
    {
        model: 'AFTJMST12',
        name: 'Fire TV Edition - Insignia 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTEAMR311',
        name: 'Fire TV Edition - Insignia HD',
        src: platformAmazon,
    },
    {
        model: 'AFTLE',
        name: 'Fire TV Edition - Onida HD',
        src: platformAmazon,
    },
    {
        model: 'AFTTIFF55',
        name: 'Fire TV Edition - Onida HD/FHD',
        src: platformAmazon,
    },
    {
        model: 'AFTWI001',
        name: 'Fire TV Edition - ok 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTEUFF014',
        name: 'Fire TV Edition - Grundig OLED 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTEU014',
        name: 'Fire TV Edition - Grundig Vision 7, 4K',
        src: platformAmazon,
    },
    {
        model: 'AFTEU011',
        name: 'Fire TV Edition - Grundig Vision 6 HD',
        src: platformAmazon,
    },
    // BrightSign devices
    {
        model: 'XT244',
        name: 'XT244 Standard I/O Player',
        src: brightsign,
    },
    {
        model: 'XT1144',
        name: 'XT1144 Expanded I/O Player',
        src: brightsign,
    },
    {
        model: 'XD234',
        name: 'XD234 Standard I/O Player',
        src: brightsign,
    },
    {
        model: 'XD1034',
        name: 'XD1034 Expanded I/O Player',
        src: brightsign,
    },
    {
        model: 'HD224',
        name: 'HD224 Standard I/O Player',
        src: brightsign,
    },
    {
        model: 'HD1024',
        name: 'HD1024 Expanded I/O Player',
        src: brightsign,
    },
    {
        model: 'LS424',
        name: ' LS424 Standard I/0 Player',
        src: brightsign,
    },
    {
        model: 'H0523',
        name: 'H0423 Player',
        src: brightsign,
    },
    // Android Devices
    {
        model: 'MIBOX3',
        name: 'Xiaomi Mi Box',
        src: mibox,
    },
    {
        model: 'MIBOX4',
        name: 'Xiaomi Mi Box S',
        src: miboxs,
    },
    {
        model: 'CLT-L29',
        name: 'Huawei P20 Pro',
        src: platformAndroid,
    },
    {
        model: 'LYA-L29',
        name: 'Huawei Mate 20 Pro',
        src: platformAndroid,
    },
    {
        model: 'H96 Max X2',
        name: 'H96 Max X2',
        src: platformAndroid,
    },
    {
        model: 'Sony Bravia 4K',
        name: 'BRAVIA 4K GB',
        src: platformAndroid,
    },
    {
        model: 'Browser',
        name: 'Web Player',
        src: browser,
    },
    {
        model: 'SM-N975U1',
        name: 'Samsung Galaxy Note 10+',
        src: platformAndroid,
    },
    {
        model: '55BDL4051D',
        name: 'Philips 55BDL4051D',
        src: platformAndroid,
    },
    // Windows Players
    {
        model: 'Intel(R) Core(TM) i3-3240 CPU @ 3.40GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i3-9100T CPU @ 3.10GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i3-3220 CPU @ 3.30GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i5-7500T CPU @ 2.70GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i7-7700 CPU @ 3.60GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i3-10100T CPU @ 3.00GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel(R) Core(TM) i5-9400 CPU @ 2.90GHz',
        name: 'Windows Player',
        platform: 'windows',
        src: platformWindows,
    },
    {
        model: 'Intel (R) Atom (TM) x5-Z8330 CPU @ 1.44GHz',
        name: 'Intel Compute Stick',
        src: intelcs,
    },
    {
        model: 'Intel(R) Core(TM) i9-9880H CPU @ 2.30GHz',
        name: 'MacBook Pro',
        src: platformMac,
    },
    {
        model: 'Intel(R) Core(TM) i5-8210Y CPU @ 1.60GHz',
        name: 'MacBook Air',
        src: platformMac,
    },
    {
        model: 'PC',
        name: 'Chrome Device',
        src: platformChromeos,
    },
    {
        model: '',
        platform: 'osx',
        name: 'Mac Device',
        src: platformMac,
    },
];
//# sourceMappingURL=devices-list.js.map